import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative py-20 bg-gradient-to-br from-rose-50 via-white to-teal-50 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-rose-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-400 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block bg-gradient-to-r from-rose-100 to-teal-100 text-gray-800 px-5 py-2 rounded-full text-sm font-bold mb-6">
            ⚖️ 徹底比較記事
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            大手ECモール系カードと三井住友カードを<br />徹底比較
          </h1>
          
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            人気2大カードを項目別に徹底比較。年会費、ポイント還元率、特典、審査難易度など、あなたに合うのはどっち？選び方のポイントを詳しく解説します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          <div className="bg-gradient-to-br from-rose-100 to-rose-50 border-2 border-rose-300 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-rose-600 rounded-2xl mx-auto mb-4 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">大手ECモール系カード</h3>
            <p className="text-gray-700 text-sm">ECモール経済圏で最強の高還元カード</p>
          </div>

          <div className="bg-gradient-to-br from-teal-100 to-teal-50 border-2 border-teal-300 rounded-2xl p-8 text-center">
            <div className="w-20 h-20 bg-teal-600 rounded-2xl mx-auto mb-4 flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">三井住友カード</h3>
            <p className="text-gray-700 text-sm">信頼のブランド力とセキュリティ</p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-md border border-gray-200">
            <i className="ri-time-line text-teal-600"></i>
            <span className="text-sm text-gray-600">更新日：2026年1月</span>
          </div>
        </div>

        {/* 1️⃣ ファーストビュー即決ブロック */}
        <div className="mt-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 shadow-2xl border-2 border-teal-400">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="bg-white/20 backdrop-blur-sm px-4 py-1 rounded-full">
              <span className="text-white text-sm font-bold">迷ったらコレ！</span>
            </div>
            <div className="bg-amber-400 px-4 py-1 rounded-full">
              <span className="text-amber-900 text-sm font-bold">総合力No.1</span>
            </div>
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-white mb-3 text-center">
            三井住友カード（NL）
          </h3>

          <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
              <div className="text-white text-xs mb-1">年会費</div>
              <div className="text-white font-bold">永年無料</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
              <div className="text-white text-xs mb-1">還元率</div>
              <div className="text-white font-bold">最大7%</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
              <div className="text-white text-xs mb-1">発行</div>
              <div className="text-white font-bold">最短10秒</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/mitsui"
              className="inline-flex items-center justify-center gap-2 bg-white text-teal-600 font-bold px-8 py-4 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line"></i>
              詳細ページを見る
            </Link>
            <a
              href="https://www.smbc-card.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-teal-700 text-white font-bold px-8 py-4 rounded-xl hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line"></i>
              公式サイトはこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
